import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AccountService } from '@core/services/account.service';
import { AppSettingsService } from '@core/services/app-settings.service';
import { RouteDataService } from '@core/services/route-data.service';
import { AppNavigation } from '@app/app.navigation';

@Component({
  selector: 'cp-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  readonly logo$ = this.settingsService.logoUrl$;
  readonly AppNavigation = AppNavigation;

  title: string = '';

  constructor(
    private readonly cd: ChangeDetectorRef,
    private readonly routeDataService: RouteDataService,
    private readonly accountService: AccountService,
    private readonly settingsService: AppSettingsService,
  ) {}

  ngOnInit(): void {
    this.subscribeToRouteChanges();
  }

  signOut(): void {
    this.accountService.logout();
  }

  private subscribeToRouteChanges(): void {
    this.routeDataService.routerDataChanged().subscribe((data) => {
      if (!data) {
        this.title = '';
      } else if (this.title !== data.title) {
        this.title = data.title as string;
      }

      this.cd.detectChanges();
    });
  }
}
